import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import { PageHeader } from "../components/common/PageHeader";
import { Badge } from "../components/ui/badge";

export default function StateMachine() {
  const [sm, setSm] = useState({ statuses: [], transitions: [] });

  useEffect(() => {
    api.get("/lifecycle/state-machine").then((r) => setSm(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <PageHeader title="Material Lifecycle Engine" subtitle="Authoritative state machine (Phase 0 foundation — read only)" />

      <div className="mb-6 rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
        <h3 className="mb-3 font-display text-base font-semibold text-slate-900">Operational Statuses ({sm.statuses.length})</h3>
        <div className="flex flex-wrap gap-2">
          {sm.statuses.map((s) => <Badge key={s} variant="secondary" className="font-mono text-[11px]">{s}</Badge>)}
        </div>
      </div>

      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-100/80">
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500">Action</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500">Transition</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500">Event</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500">Actor</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500">Permission</th>
            </tr>
          </thead>
          <tbody>
            {sm.transitions.map((t, i) => (
              <tr key={i} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 text-sm font-medium text-slate-800">{t.action}</td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2 font-mono text-[11px] text-slate-600">
                    <span>{(t.from || []).map((f) => f || "—").join(" / ")}</span>
                    <ArrowRight className="h-3 w-3 text-blue-500" />
                    <span className="text-blue-700">{t.to}</span>
                  </div>
                </td>
                <td className="px-4 py-3">{t.event ? <Badge variant="outline" className="font-mono text-[10px] text-slate-600">{t.event}</Badge> : <span className="text-slate-300">—</span>}</td>
                <td className="px-4 py-3 text-sm text-slate-600">{t.actor}</td>
                <td className="px-4 py-3"><Badge variant="secondary" className="font-mono text-[10px]">{t.permission}</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
